import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGame } from '../contexts/GameContext';
import '../styles/HoneyInfo.css';

const HoneyInfo = () => {
  const navigate = useNavigate();
  const { honeyTypes } = useGame();
  const [activeHoney, setActiveHoney] = useState(honeyTypes[0].id);

  // Función para manejar el regreso a la página principal
  const handleBackToHome = () => {
    // Navegar a la página principal sin detener la música
    navigate('/');
  };

  return (
    <div className="honey-info-container">
      <h1>Información sobre Mieles</h1>
      
      <div className="honey-tabs">
        {honeyTypes.map(honey => (
          <button
            key={honey.id}
            className={`honey-tab ${activeHoney === honey.id ? 'active' : ''}`}
            onClick={() => setActiveHoney(honey.id)}
          >
            {honey.name}
          </button>
        ))}
      </div>
      
      <div className={`honey-details ${activeHoney}-bg`}>
        {honeyTypes.map(honey => (
          activeHoney === honey.id && (
            <div 
              key={honey.id} 
              className="honey-card active"
            >
              <div className="honey-image-container">
                <img 
                  src={`/assets/images/${honey.id === 'citricos' ? 'citrico.jpg' : honey.id === 'eucalipto' ? 'eucalipto.jpg' : 'trebol.jpg'}`} 
                  alt={honey.name} 
                  className="honey-image" 
                />
              </div>
              
              <div className="honey-info">
                <h2>{honey.name}</h2>
                <p className="honey-description">{honey.description}</p>
                
                <h3>Características</h3>
                <ul className="characteristics-list">
                  {honey.characteristics.map((characteristic, index) => (
                    <li key={index}>
                      <span className="characteristic-icon">✓</span>
                      {characteristic}
                    </li>
                  ))}
                </ul>
                
                <div className="honey-origin">
                  <h3>Origen</h3>
                  <p>{getHoneyOrigin(honey.id)}</p>
                </div>
              </div>
            </div>
          )
        ))}
      </div>
      
      <button 
        className="btn btn-primary back-btn"
        onClick={handleBackToHome}
      >
        Volver al Inicio
      </button>
    </div>
  );
};

// Función auxiliar para obtener el origen de cada miel
function getHoneyOrigin(honeyId) {
  switch (honeyId) {
    case 'citricos':
      return 'Origen botánico: (Citrus sp). Producida en Entre Ríos a partir del néctar de las flores de cítricos. Para considerar que una miel es de citrus en su composición se deben encontrar presentes un mínimo de 10 a 20% de granos de pólenes de citrus.';
    case 'eucalipto':
      return 'Origen botánico: (Eucalyptus sp). Producida en Entre Ríos a partir del néctar de las flores de eucalipto. Para considerar que una miel es de eucalipto en su composición se deben encontrar presentes como mínimo un 70% de granos de polen de dicha especie.';
    case 'treboles':
      return 'Origen botánico: (Trifolium sp). Producida en las praderas de Entre Ríos. Al denominar una miel como miel de trébol, en su composición se pueden encontrar pólenes correspondientes a diferentes géneros, como Melilotus P. Mill., Medicago L. y Trifolium L., todos integrantes de la tribu Trifolieae, alcanzando un valor mínimo en su conjunto de 45%.';
    default:
      return 'Información sobre el origen no disponible.';
  }
}

export default HoneyInfo;
